import { Component, OnInit, AfterViewInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-Non-Profit',
    templateUrl: './Non-Profit.component.html',
    styleUrls: ['./Non-Profit.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NonProfitComponent implements OnInit, AfterViewInit {

  id: number;

  constructor(private actRoute: ActivatedRoute) {
    this.id = this.actRoute.snapshot.params.id;
  }
  ngAfterViewInit() {

  }

  ngOnInit() {

  }

}
